import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";

import { OrderLineStatus } from "@/types/service/cart/shared";

import CnCOrderItemStatus from "./Cnc/cnc.component";
import DSVOrderItemStatus from "./Dsv/dsv.component";

type Props = {
    statuses: Array<OrderLineStatus>;
    deliveryType: DeliveryType | null;
    transportStatusMessage?: string | null;
};

const OrderItemStatus = ({
    statuses,
    deliveryType,
    transportStatusMessage
}: Props) => {
    return (
        <>
            {deliveryType === DeliveryType.ClickAndCollect && (
                <CnCOrderItemStatus statuses={statuses} />
            )}
            {deliveryType === DeliveryType.HomeDelivery && (
                <DSVOrderItemStatus message={transportStatusMessage} />
            )}
        </>
    );
};

export default OrderItemStatus;
